var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRubyAlt1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_315)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_28_315)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.955 185.764L23.8039 177.142L13.9999 48.916L52.743 127.456L150.955 185.764Z",
    fill: "#BE4234"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.2885 140.915L23.589 177.035L34.511 101.613L64.2885 140.915V140.915Z",
    fill: "url(#paint0_linear_28_315)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.525 185.592L23.4385 177.035L103.505 170.757L150.525 185.592V185.592Z",
    fill: "url(#paint1_linear_28_315)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.411 129.498L150.418 185.613L130.401 120.081L174.411 129.498V129.498Z",
    fill: "#BE4234"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.368 118.426L64.2885 141.13L82.6926 69.0615L135.368 118.426V118.426Z",
    fill: "#BE4234"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.8325 74.2215L18.171 70.072L67.965 29.4155L81.8325 74.2215V74.2215Z",
    fill: "#BE4234"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.207 14.688L41.4555 14.903L70.7385 31.0925L89.207 14.688Z",
    fill: "#BE4234"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.657 102.451L186 151.471L173.724 129.111L183.657 102.451V102.451Z",
    fill: "#BE4234"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.323 101.613L174.325 129.928L130.96 120.21L81.424 74.2001L67.449 29.8026L89.465 14.2366L126.875 28.2331C138.7 39.1981 161.533 60.8916 162.35 61.3001C163.167 61.7086 177.4 88.7341 184.323 101.613Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.223 92.9617C129.83 118.289 162.703 133.253 175.345 120.503C187.987 107.754 174.571 76.7722 149.029 51.4452C123.487 26.1182 90.9575 10.3157 78.2295 23.0867C65.5015 35.8577 78.6595 67.6347 104.223 92.9617V92.9617Z",
    fill: "#C13F3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.417 185.591L130.551 119.844L64.654 141.022C88.476 163.382 115.05 182.259 150.417 185.591Z",
    fill: "url(#paint2_linear_28_315)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.338 74.0494L64.4175 141.065C44.5085 120.124 26.642 97.6349 17.8915 69.8999L81.338 74.0494Z",
    fill: "url(#paint3_linear_28_315)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0635 70.1365C11.291 49.7115 9.7 20.45 41.6705 14.946L67.75 29.4155L18.0635 70.1365Z",
    fill: "url(#paint4_linear_28_315)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186 151.191C185.054 184.903 160.737 185.419 150.374 185.591L174.304 129.691L186 151.191Z",
    fill: "#AA3E35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.252 74.2001C65.944 83.5956 35.1129 102.473 34.4894 102.817C33.5219 103.376 21.2025 82.0476 18.4075 70.0076L81.252 74.2001Z",
    fill: "url(#paint5_radial_28_315)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.594 119.844L104.063 170.95C89.6212 162.928 76.4129 152.862 64.8475 141.065L130.594 119.844Z",
    fill: "url(#paint6_radial_28_315)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.411 129.863L178.174 174.626C171.079 184.301 161.318 185.161 151.084 184.409C158.48 165.962 173.272 129.111 174.411 129.863Z",
    fill: "url(#paint7_linear_28_315)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.0295 29.5231L15.3115 36.9191C18.128 25.0081 26.771 17.3111 41.4985 14.9031L68.0295 29.5231Z",
    fill: "url(#paint8_linear_28_315)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28_315",
    x1: 16.8165,
    y1: 147.537,
    x2: 63.579,
    y2: 116.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B3F34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A23E36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A23E36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_28_315",
    x1: -7638.61,
    y1: 1476.98,
    x2: -7520.91,
    y2: 800.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B3F34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#A23E36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A23E36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_28_315",
    x1: 100,
    y1: 162.715,
    x2: 140.14,
    y2: 152.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F3633"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A73532"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B13439"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B13439"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_28_315",
    x1: 31.028,
    y1: 114.512,
    x2: 66.6965,
    y2: 82.5419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#923C36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#AA3531"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA3531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_28_315",
    x1: 17.913,
    y1: 55.8605,
    x2: 35.6935,
    y2: 36.8545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D3E36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#AA3E37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA3E37"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_28_315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.128 83.1656) rotate(180) scale(43.7095 43.7095)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B13430"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#923934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#923934"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_28_315",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(121.672 140.764) rotate(180) scale(58.1145 58.1145)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE3531"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#953A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#953A36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_28_315",
    x1: 162.844,
    y1: 185.548,
    x2: 177.335,
    y2: 136.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#994939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#AA3A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#B83936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B83936"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_28_315",
    x1: 51.754,
    y1: 22.7506,
    x2: 19.289,
    y2: 37.0696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9392F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#A23A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#8D463A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D463A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_28_315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 172,
    height: 172,
    fill: "white",
    transform: "matrix(-1 0 0 1 186 14)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRubyAlt1);
export default __webpack_public_path__ + "static/media/ruby-alt1.cabfd380b296b345278d9d5ca3dde9a6.svg";
export { ForwardRef as ReactComponent };